<template>
  <div class="form-row">
    <div class="form-check form-check-inline" v-for="attribute in featureAttributes">
      <input @change="manageCheckboxStatus(attribute)" v-model="selectedItems" class="form-check-input" type="checkbox"
             :id="`feature_attribute_${staticGenerateHash}_${attribute.id}`" :value="attribute.id">
      <label class="form-check-label mr-2"
             :for="`feature_attribute_${staticGenerateHash}_${attribute.id}`">{{ attribute.value }}</label>
      <div v-if="selectedItems.indexOf(attribute.id) > -1">
        <checkbox-item-image :attribute="attribute" :product="product"/>

        <feature-item-extra :product="product" :product-feature="findFeatureItem(attribute)"/>
        <feature-remove-image-button :product-feature="findFeatureItem(attribute)" class="my-1"/>
      </div>
    </div>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import CheckboxItemImage from "./CheckboxItemImage.vue";
import FeatureItemExtra from "@/plugin/components/dashboard/product/productFeatureComponents/FeatureItemExtra.vue";
import FeatureRemoveImageButton from "./FeatureRemoveImageButton.vue";

export default {
  name: "CheckboxItemConfig",
  components: {FeatureRemoveImageButton, FeatureItemExtra, CheckboxItemImage},
  props: {
    productFeature: {},
    product: {}
  },
  data() {
    return {
      selectedItems: []
    }
  },
  computed: {
    featureAttributes() {
      return this.firstFeatureAttribute.feature.feature_attributes
    },
    staticGenerateHash() {
      return this.generateHash()
    },
    firstFeatureAttribute() {
      return this.productFeature[0]
    }
  },
  methods: {
    generateHash,
    defineSelectedFeatureAttribute() {
      this.selectedItems = []
      this.productFeature.forEach(item => {
        this.selectedItems.push(item.feature_attribute_id)
      })
    },
    removeFeature(attribute) {
      this.product.features.forEach((item, index) => {

        if (item.feature_attribute_id === attribute.id) {

          const form = {
            product_id: this.product.id,
            feature_product: [item.id],
          }

          if (!isNaN(parseFloat(item.id)) && isFinite(item.id)) {
            this.$store.dispatch('Product/deleteProductFeature', form).then(res => {
              this.product.features.splice(index, 1)
            })
          } else {
            this.product.features.splice(index, 1)
          }

        }

      })
    },
    addFeature(attribute) {
      let baseShape = Object.assign({}, this.firstFeatureAttribute)
      delete baseShape['id'];
      baseShape['feature_attribute_id'] = attribute.id
      this.product.features.push(baseShape)
    },
    manageCheckboxStatus(attribute) {
      const checkStatus = this.selectedItems.indexOf(attribute.id) > -1

      if (checkStatus) {
        this.addFeature(attribute)
      } else {
        this.removeFeature(attribute)
      }

    },
    findFeatureItem(attribute) {
      let result = null
      this.productFeature.forEach(item => {
        if (item.feature_attribute_id == attribute.id) {
          result = item
        }
      })
      return result
    }
  },
  mounted() {
    this.defineSelectedFeatureAttribute()
  }
}
</script>

<style scoped>

</style>